import { storable } from '$lib/utils/storable';

export const FEATURES = [
  { key: 'clientHealthPlan', label: 'Client Health Plan', description: '' },
  { key: 'messagingLogs', label: 'Messaging Logs', description: '' },
  {
    key: 'aiSuggestionInfo',
    label: 'AI Suggestion Info',
    description: 'Show technical info about AI suggestion, model, price etc.',
  },
  {
    key: 'knowledge',
    label: 'AI',
  },
  {
    key: 'okr',
    label: 'OKR',
  },
  {
    key: 'testingTools',
    label: 'Testing Tools',
    description: 'Manual triggering of cron jobs and testing utilities',
  },
];

export const features = storable('feature-flags', {
  clientHealthPlan: false,
  messagingLogs: false,
  aiSuggestionInfo: false,
  knowledge: false,
  okr: false,
  testingTools: false,
});
